import { useFormik } from "formik";
import { useMutation, useApolloClient } from "@apollo/client";

import { FETCH_LISTS as fetchLists } from "../../../graphql/query/List";
import { UPDATE_LIST as updateListMutation } from "../../../graphql/mutation/List";
import { Button, getInput, Modal } from "../../ui";

const SaveList = props => {
  const { disabled, workingListId, onSuccess, typeId } = props || {};
  const formik = useFormik({
    initialValues: {
      name: "",
    },
  });
  const client = useApolloClient();
  const [updateList, { loading }] = useMutation(updateListMutation(), {
    refetchQueries: [
      {
        query: fetchLists(),
        variables: { input: { typeId } },
        fetchPolicy: "network-only",
      },
    ],
    awaitRefetchQueries: true,
    onCompleted: async () => { 
      // Also refetch all other FetchLists queries to ensure cache is fully cleared
      await client.refetchQueries({
        include: ["FetchLists"],
      });
    },
  });

  const handleSaveList = closeModal => async e => {
    e.preventDefault();

    // Validate required fields
    if (!workingListId) {
      console.error("Cannot save list: workingListId is missing");
      return;
    }

    if (!formik?.values?.name?.trim()) {
      console.error("Cannot save list: name is required");
      return;
    }

    const res = await updateList({
      variables: {
        input: {
          id: workingListId,
          name: formik?.values?.name?.trim(),
          typeId: typeId,
        },
      },
    });
    if (res?.data?.updateList?.success) {
      onSuccess?.();
      closeModal?.();
    } else if (res?.data?.updateList?.error) {
      console.error("Error saving list:", res.data.updateList.error);
    }
  };

  const inputProps = {
    formik,
    label: "Select List Name",
    name: "name",
    type: "text",
  };

  const modalProps = {
    title: "",
    scale: "md",
    hideCloseButton: true,
    closeOnBackdrop: false,
    disabled: disabled,
    renderBody: ({ closeModal }) => {
      return (
        <form className={`p-4`} onSubmit={handleSaveList(closeModal)}>
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div className={`text-lg`}>Save Select List</div>
            <div className="flex flex-wrap gap-2 sm:gap-6">
              <Button
                type="button"
                className={`!w-28`}
                action="default"
                label="Cancel"
                onClick={closeModal}
              />
              <Button
                type="submit"
                loading={loading}
                disabled={!formik?.values?.name}
                className={`flex !w-28 items-center`}
                label={loading ? "Saving" : "Save List"}
              />
            </div>
          </div>
          <div className="mt-8 w-full text-sm font-normal sm:w-1/2">
            {getInput(inputProps)}
          </div>
        </form>
      );
    },
  };

  return (
    <Modal {...modalProps}>
      <Button label="Save Select List" disabled={disabled || !workingListId} />
    </Modal>
  );
};

export default SaveList;
